//common funcs
import { screenHeight } from "./common/function/screenheight.es6";
import { gnav } from "./common/function/gnav.es6";
import { ready } from "./common/function/ready.es6";
import { pageheader } from "./common/function/pageheader.es6";
import { castcomment } from "./common/function/castcomment.es6";
import { fixedshare } from "./common/function/fixedshare.es6";

//common classes
import Modal from "./common/classes/modal.es6";
import ScrollFunc from "./common/classes/scrollfunc.es6";
import Movie from "./common/classes/movie.es6";

class Common {
    constructor() {
        this.modal = new Modal();
        this.scrollFunc = new ScrollFunc();
        this.movie = new Movie();

        this.init();
    }

    init() {
        //common funcs
        screenHeight();
        gnav();
        ready();
        pageheader();
        fixedshare();
        castcomment();
    }

    resetModalEvents() {
        this.modal.resetEvent();
    }
}

const common = new Common();
